import _toConsumableArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
var _excluded = ["default"];
var __defProp = Object.defineProperty;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

  return value;
};

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var __privateMethod = function __privateMethod(obj, member, method) {
  __accessCheck(obj, member, "access private method");

  return method;
}; // src/base.ts


import { goerli, mainnet } from "@wagmi/core/chains";
import { default as EventEmitter } from "eventemitter3";

var Connector = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  var _super = _createSuper(Connector);

  function Connector(_ref) {
    var _this;

    var _ref$chains = _ref.chains,
        chains = _ref$chains === void 0 ? [mainnet, goerli] : _ref$chains,
        options = _ref.options;

    _classCallCheck(this, Connector);

    _this = _super.call(this);

    __publicField(_assertThisInitialized(_this), "chains");

    __publicField(_assertThisInitialized(_this), "options");

    _this.chains = chains;
    _this.options = options;
    return _this;
  }

  _createClass(Connector, [{
    key: "getBlockExplorerUrls",
    value: function getBlockExplorerUrls(chain) {
      var _chain$blockExplorers;

      var _ref2 = (_chain$blockExplorers = chain.blockExplorers) !== null && _chain$blockExplorers !== void 0 ? _chain$blockExplorers : {},
          blockExplorer = _ref2.default,
          blockExplorers = _objectWithoutProperties(_ref2, _excluded);

      if (blockExplorer) return [blockExplorer.url].concat(_toConsumableArray(Object.values(blockExplorers).map(function (x) {
        return x.url;
      })));
    }
  }, {
    key: "isChainUnsupported",
    value: function isChainUnsupported(chainId) {
      return !this.chains.some(function (x) {
        return x.id === chainId;
      });
    }
  }]);

  return Connector;
}(EventEmitter);

export { __publicField, __privateGet, __privateAdd, __privateSet, __privateMethod, Connector };